/** Flip to false to restore Task 2 voice practice. */
export const TASK_2_MAINTENANCE = false;

export function isTask2MaintenanceEnabled(): boolean {
  return TASK_2_MAINTENANCE;
}
